// extracted by mini-css-extract-plugin
export default {"mainContainer":"Skills_mainContainer__a102d","content":"Skills_content__5YpfM"};